import { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, ENDPOINTS } from '../../config';
import 'notyf/notyf.min.css';
import { Notyf } from 'notyf';
import MainHeader from '../Sidebar/MainHeader';
const notyf = new Notyf({
  position: {
    x: 'right',
    y: 'top'
  },
  ripple: true,
  dismissible: true,
});
const History = () => {
  const [chats, setChats] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [cookies] = useCookies(['token']);

  useEffect(() => {
    const fetchChats = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}${ENDPOINTS.CHATS.GET_ALL}`,
          {
            headers: {
              Authorization: `Bearer ${cookies.token}`
            }
          }
        );
        setChats(response.data);
      } catch (err) {
        notyf.error(err.response?.data?.detail || 'Failed to load chat history');
      } finally {
        setIsLoading(false);
      }
    };

    if (cookies.token) {
      fetchChats();
    }
  }, [cookies.token]);

  const deleteChat = async (chatId) => {
    try {
      await axios.delete(
        `${API_BASE_URL}${ENDPOINTS.CHATS.DELETE}/${chatId}`,
        {
          headers: {
            Authorization: `Bearer ${cookies.token}`
          }
        }
      );
      setChats(prev => prev.filter(chat => chat.chat_id !== chatId));
      notyf.success('Chat deleted successfully');
    } catch (err) {
      notyf.error(err.response?.data?.detail || 'Failed to delete chat');
    }
  };

  if (isLoading) {
    return <div className="loading-spinner">Loading...</div>;
  }

  return (

    <main class="main-content">
      <MainHeader></MainHeader>
      <div class="container-fluid py-4 px-4">
        <h4>Chat History</h4>
        <p>Choose a template or start from scratch</p>
        <div class="models-container">
          <div className="row g-4">
            {chats.map((chat) => (
              <div key={chat.chat_id} className="col-lg-6 col-md-12 model-item">
                <div className="model-card">

                  {/* Header */}
                  <div className="model-header">
                    <h5 className="model-name">
                      {chat.messages[1]?.content || chat.title}
                    </h5>
                    <p>
                      <small>
                        {new Date(chat.created_at).toLocaleDateString()}
                      </small>
                    </p>
                  </div>

                  {/* Body */}
                  <div className="model-body">
                    <p>
                      {chat.messages[2]?.content?.slice(0, 80) || chat.title}...
                    </p>
                  </div>

                  {/* Actions */}
                  <div className="model-actions d-flex gap-2">
                    <button
                      className="btn btn-xs btn-outline-danger"
                      onClick={() => deleteChat(chat.chat_id)}
                    >
                      <i className="fa-solid fa-trash"></i>
                    </button>

                    <Link
                      to={`/c/${chat.chat_id}`}
                      className="btn btn-xs btn-outline-success"
                    >
                      <i className="fa-solid fa-arrow-right"></i>
                    </Link>
                  </div>

                </div>
              </div>
            ))}
          </div>
        </div>


      </div>
    </main>
  );
};

export default History;